<template>
  <div v-bem>
    <h2 class="title">Nous trouver ?</h2>
    <div v-bem:container>
      <GmapMap ref="succMap" :options="options" :center="center">
        <GmapMarker
          v-for="succursale in succursales"
          :key="succursale.id"
          :position="succursale.coordinates"
          @click="goToMaps(succursale.coordinates)"
          v-if="succursale.id === succ.id"
        />
      </GmapMap>
      <div v-bem:succursales v-bar>
        <div>
          <div
            v-for="succursale in succursales"
            :key="succursale.id"
            v-bem:succursales:item="{ active: succ.id === succursale.id }"
            @click="selectSucc(succursale)"
          >
            <img src="@/assets/img/icons/pin.svg" alt=""><p>{{succursale.name}}</p>
          </div>
        </div>
      </div>
      <div v-bem:succ>
        <p class="name"><img src="@/assets/img/icons/pin.svg" alt="">{{succ.name}}</p>
        <p>Adresse : {{succ.address}}</p>
        <p>Téléphone : {{succ.tel}}</p>
        <a :href="`tel:${succ.tel}`" class="button button--primary">
          <span class="button__text">Appelez-nous</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Map',
  data: () => ({
    center: {},
    options: {
      zoom            : 13,
      disableDefaultUI: true,
    },
    succ: {
    },
    succursales: [
      {
        id         : 0,
        name       : 'SUCCURSALE RENAULT LISSASFA',
        address    : 'Lissasfa Parc, Km12 Route El Jadida Casablanca',
        tel        : '05 20 48 20 07',
        coordinates: { lat: 33.526486, lng: -7.682495 }
      },
      {
        id         : 1,
        name       : 'SUCCURSALE RENAULT BANDOENG - DERB OMAR',
        address    : '1, Place Bandoeng, Casablanca',
        tel        : '05 22 54 82 00',
        coordinates: { lat: 33.603183, lng: -7.534155 }
      },
      {
        id         : 2,
        name       : 'SUCCURSALE RENAULT SIDI OTHMANE',
        address    : 'Angle Bd Mohammed Bouziane et Bd Colonel Al Allam, Hay Salama 3, Sidi Othmane',
        tel        : '05 20 48 20 06',
        coordinates: { lat: 33.564112, lng: -7.555402 }
      },
      {
        id         : 3,
        name       : 'SUCCURSALE RENAULT SIDI MAÂROUF',
        address    : '1, Lotissement Tawfik Sidi Maarouf',
        tel        : '05 20 48 20 01',
        coordinates: { lat: 33.515575, lng: -7.658308 }
      },
      {
        id         : 4,
        name       : 'SUCCURSALE RENAULT MOULAY ISMAIL - ROCHES NOIRES',
        address    : '89, Angle boulevard Moulay Ismail et rue Bourred, Roches Noires',
        tel        : '05 20 48 20 05',
        coordinates: { lat: 33.598071, lng: -7.585381 }
      },
      {
        id         : 5,
        name       : 'SUCCURSALE RENAULT VITA - AÏN SEBAÂ',
        address    : '44, Bd Khalid Ibnou Al Walid Ain Sebaa',
        tel        : '05 20 48 20 08',
        coordinates: { lat: 33.603582, lng: -7.534403 }
      }
    ]
  }),
  methods: {
    selectSucc(succ) {
      this.succ = succ;
      this.$refs.succMap.$mapPromise.then((map) => {
        map.panTo(succ.coordinates)
      })
    },
    goToMaps({lat, lng}) {
      window.open(`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${lat},${lng}`,'_blank','noopener');
    }
  },
  created() {
    this.succ   = this.succursales[0];
    this.center = this.succursales[0].coordinates;
  }
}
</script>

<style scoped lang="scss">
.map {
  &__container {
    position: relative;
    margin: 0 auto;
    max-width: rem(1200);
    height: rem(600);
    .vue-map-container {
      width: 100%;
      height: 100%;
    }
  }
  &__succursales {
    position: absolute !important;
    top: rem(30);
    left: 0;
    background-color: $white;
    height: rem(176);
    width: rem(250);
    &-item {
      position: relative;
      padding: rem(14) rem(10);
      cursor: pointer;
      transition: background 0.4s;
      p {
        font-family: var(--primary-font-bold);
        @include font-size(10);
      }
      img {
        transform: translateY(rem(-5));
        margin-right: rem(10);
        height: rem(20);
        float: left;
      }
      &:after {
        content: "";
        @extend %transform-center-vertical;
        left: 100%;
        border-color: transparent transparent transparent rgba(var(--primary-color), 1);
        border-style: solid;
        border-width: rem(10);
        display: none;
      }
      &--active {
        background-color: rgba(var(--primary-color), 1);
        &:after {
          display: block;
        }
      }
      &:hover {
        background-color: rgba(var(--primary-color), 1);
      }
    }
  }
  &__succ {
    position: absolute;
    right: rem(30);
    bottom: 0;
    background-color: $white;
    padding: rem(30) rem(40);
    text-align: center;
    border: rem(2) solid rgba(var(--primary-color), 1);
    max-width: rem(400);
    p {
      @include font-size(12);
      margin-bottom: rem(15);
    }
    p.name {
      position: relative;
      font-family: var(--primary-font-bold);
      @include font-size;
      img {
        vertical-align: middle;
        margin-right: rem(10);
        height: rem(30);
      }
      &::after {
        content: "";
        width: rem(60);
        height: rem(4);
        background-color: rgba(var(--primary-color), 1);
        display: table;
        margin: rem(10) auto rem(30);
      }
    }
    .button {
      display: table;
      margin: rem(20) auto;
    }
  }
  @include breakpoint('charmander') {
  &__container {
    height: initial;
    .vue-map-container {
      width: 100%;
      height: rem(400);
    }
  }
    &__succursales {
      top: 0;
      height: rem(144);
      &-item {
        padding: rem(15) rem(15) rem(15) rem(5);
      }
    }
    &__succ {
      position: initial;
      width: 100%;
    }
  }
}
</style>